import React from 'react';
import { Tag } from './PaperTag.styles';

export interface PaperTagProps {
  children?: string;
  className?: string;
  foil?: boolean;
}

const PaperTag = ({ children, className, foil }: PaperTagProps): JSX.Element => (
  <Tag className={className} foil={foil}>
    {children}
  </Tag>
);

export default PaperTag;
